import { render, staticRenderFns } from "./discussItem.vue?vue&type=template&id=7b81f97b&scoped=true"
import script from "./discussItem.vue?vue&type=script&lang=js"
export * from "./discussItem.vue?vue&type=script&lang=js"
import style0 from "./discussItem.vue?vue&type=style&index=0&id=7b81f97b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81f97b",
  null
  
)

export default component.exports